import { useIntl } from '@finn/ui-utils';

import { GenericVehicleDetails } from '../../core/types';
import { useConfigureStore } from '../../pdp-management';
import { useDeliveryText } from '../hooks/useDeliveryText';

export const AvailabilityElements = ({
  vehicle,
}: {
  vehicle: GenericVehicleDetails;
}) => {
  const intl = useIntl();
  const { term } = useConfigureStore();
  const deliveryText = useDeliveryText(vehicle, term);

  const { availability } = vehicle;

  const hasLowStock = availability <= 3;
  const lowStockLabel = intl.formatMessage(
    `general.${availability > 1 ? 'leftInStockPlural' : 'leftInStockSingular'}`,
    { total: availability }
  );

  return (
    <div className="flex flex-col gap-3">
      <div className="body-16-semibold">
        <span>{deliveryText}</span>
      </div>
      {hasLowStock && <p className="body-16-light">{lowStockLabel}</p>}
    </div>
  );
};
